import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "InfoList" }
const _hoisted_3 = { class: "inputLabelTop" }
const _hoisted_4 = { class: "tabList" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "input_container"
}
const _hoisted_7 = {
  key: 1,
  class: "input_container"
}
const _hoisted_8 = {
  key: 2,
  class: "input_container"
}
const _hoisted_9 = {
  key: 3,
  class: "input_container"
}
const _hoisted_10 = {
  key: 4,
  class: "errorText"
}
const _hoisted_11 = { class: "input_container" }
const _hoisted_12 = { class: "inputLabel" }
const _hoisted_13 = { class: "input_container" }
const _hoisted_14 = {
  key: 5,
  class: "errorText"
}
const _hoisted_15 = {
  key: 6,
  class: "input_container"
}
const _hoisted_16 = { class: "inputLabel" }
const _hoisted_17 = {
  key: 7,
  class: "input_container"
}
const _hoisted_18 = { class: "inputLabel" }

import { ref, watch, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { nextTick } from 'vue'
import { TAB_TYPE_LIST, WithdrawPopupData } from '@/view/withdraw/supportScript';
import { useWithdrawStore } from '@/stores/withdraw';

export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawPopup',
  props: {
    dataSetTwo: {}
  },
  emits: ['close', 'open', 'selectTabType', 'confirmWithdrawPopup', 'updateFormValues', 'changeValue', 'checkFieldsFill'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const { t } = useI18n();


const props = __props

const withdrawStore = useWithdrawStore()
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref(props.dataSetTwo.cpfID)
const emailID = ref(props.dataSetTwo.emailID)
const phoneID = ref(props.dataSetTwo.phoneID)
const evpID = ref(props.dataSetTwo.evpID)
const userName = ref(props.dataSetTwo.userName)
const cpfNumber = ref(props.dataSetTwo.cpfNumber)
const brazilID = ref(props.dataSetTwo.brazilID)
const bank = ref(props.dataSetTwo.bank)
const showCPFIdError = ref(props.dataSetTwo.showCPFIdError)
const showEmaiIdError = ref(props.dataSetTwo.showEmaiIdError)
const showPhoneIdError = ref(props.dataSetTwo.showPhoneIdError)
const showEvpIdError = ref(props.dataSetTwo.showEvpIdError)
const showCPFNumError = ref(props.dataSetTwo.showCPFNumError)
const activeButton = ref(false)

const emits = __emit

const open = (amount: number, data: any) => {
    emits('open')
}
const close = () => {
    emits('close')
}

const selectTabType = (item: any) => {
    activeTab.value = item
    emits('selectTabType', item)
}

const confirmWithdraw = () => {
    emitFormValues()
    emits('confirmWithdrawPopup')
}

const emitFormValues = () => {
    emits('updateFormValues', {
        cpfID: cpfID.value,
        emailID: emailID.value,
        phoneID: phoneID.value,
        evpID: evpID.value,
        userName: userName.value,
        cpfNumber: cpfNumber.value,
        brazilID: brazilID.value,
        bank: bank.value,
        activeTab: props.dataSetTwo.activeTab,
    })
}

watch(() => props.dataSetTwo, (newVal) => {
    if (cpfID.value !== newVal.cpfID) cpfID.value = newVal.cpfID
    if (emailID.value !== newVal.emailID) emailID.value = newVal.emailID
    if (phoneID.value !== newVal.phoneID) phoneID.value = newVal.phoneID
    if (evpID.value !== newVal.evpID) evpID.value = newVal.evpID
    if (userName.value !== newVal.userName) userName.value = newVal.userName
    if (cpfNumber.value !== newVal.cpfNumber) cpfNumber.value = newVal.cpfNumber
    if (brazilID.value !== newVal.brazilID) brazilID.value = newVal.brazilID
    if (bank.value !== newVal.bank) bank.value = newVal.bank
}, { deep: true })


watch(cpfID, (val) => {
    if (val.length == 11) {
        showCPFIdError.value = false
    } else {
        showCPFIdError.value = true
    }
    let data = {
        type: 'cpfID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(emailID, (val) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(val)) {
        showEmaiIdError.value = false
    } else {
        showEmaiIdError.value = true
    }
    let data = {
        type: 'emailID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(phoneID, (val) => {
    if (val.length == 11) {
        showPhoneIdError.value = false
    } else {
        showPhoneIdError.value = true
    }
    let data = {
        type: 'phoneID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(evpID, (val) => {
    if (val.length > 0) {
        showEvpIdError.value = false
    } else {
        showEvpIdError.value = true
    }
    let data = {
        type: 'evpID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(cpfNumber, (val) => {
    if (val.length == 11 || val.length == 0) {
        showCPFNumError.value = false
    } else {
        showCPFNumError.value = true
    }
    let data = {
        type: 'cpfNumber',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(userName, (val) => {
    let data = {
        type: 'userName',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(brazilID, (val) => {
    let data = {
        type: 'brazilID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(bank, (val) => {
    let data = {
        type: 'bank',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})

watch(activeTab, () => {
  checkFieldsFill()
})

const checkFieldsFill = () => {
    const activeId = activeTab.value.id 
    if (activeId === 1) {
        activeButton.value = (cpfID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showCPFIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 2) {
        activeButton.value = (emailID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEmaiIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 3) {
        activeButton.value = (phoneID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showPhoneIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 4) {
        activeButton.value = (evpID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEvpIdError.value &&
            !showCPFNumError.value
    }
    emits('checkFieldsFill', activeButton.value)
}


__expose({
    open,
    close,
    confirmWithdraw,
})


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('withdraw.taxIdType')), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TAB_TYPE_LIST), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tab_card", activeTab.value.id == item.id ? 'active_tab' : '']),
            key: item.id,
            onClick: ($event: any) => (selectTabType(item))
          }, _toDisplayString(item.name), 11, _hoisted_5))
        }), 128))
      ]),
      (activeTab.value.id == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_van_field, {
              modelValue: cpfID.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cpfID).value = $event)),
              type: "number",
              disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.cpf != null && _unref(withdrawStore).withdrawInfo.cpf != '',
              placeholder: _ctx.$t('withdraw.cpfIdPlaceholder')
            }, {
              "left-icon": _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "inputLabel" }, "CPF ID", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value.id == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_van_field, {
              modelValue: emailID.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailID).value = $event)),
              disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.email != null && _unref(withdrawStore).withdrawInfo.email != '',
              placeholder: _ctx.$t('withdraw.emailPlaceholder')
            }, {
              "left-icon": _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "inputLabel" }, "Email ID", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value.id == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_van_field, {
              modelValue: phoneID.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phoneID).value = $event)),
              type: "number",
              disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.phone != null && _unref(withdrawStore).withdrawInfo.phone != '',
              placeholder: _ctx.$t('withdraw.phonePlaceholder')
            }, {
              "left-icon": _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("div", { class: "inputLabel" }, "PHONE ID", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value.id == 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_van_field, {
              modelValue: evpID.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((evpID).value = $event)),
              disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.evpId != null && _unref(withdrawStore).withdrawInfo.evpId != '',
              placeholder: _ctx.$t('withdraw.evpPlaceholder')
            }, {
              "left-icon": _withCtx(() => _cache[11] || (_cache[11] = [
                _createElementVNode("div", { class: "inputLabel" }, "EVP", -1)
              ])),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value.id == 1 && showCPFIdError.value
                || activeTab.value.id == 2 && showEmaiIdError.value
                || activeTab.value.id == 3 && showPhoneIdError.value
                || activeTab.value.id == 4 && showEvpIdError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)(activeTab.value.errorText)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_van_field, {
          modelValue: userName.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((userName).value = $event)),
          disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.userName != null && _unref(withdrawStore).withdrawInfo.userName != '',
          placeholder: _ctx.$t('withdraw.userNamePlaceholder')
        }, {
          "left-icon": _withCtx(() => [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('withdraw.name')), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_van_field, {
          modelValue: cpfNumber.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((cpfNumber).value = $event)),
          type: "number",
          disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.cpfId != null && _unref(withdrawStore).withdrawInfo.cpfId != '',
          placeholder: _ctx.$t('withdraw.userNamePlaceholder')
        }, {
          "left-icon": _withCtx(() => _cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "inputLabel" }, "CPF", -1)
          ])),
          _: 1
        }, 8, ["modelValue", "disabled", "placeholder"])
      ]),
      (showCPFNumError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t("withdraw.cpfErrorText")), 1))
        : _createCommentVNode("", true),
      (_ctx.dataSetTwo?.selectedChannel.channelType == '7')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_van_field, {
              modelValue: brazilID.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((brazilID).value = $event)),
              disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.brazilId != null && _unref(withdrawStore).withdrawInfo.brazilId != '',
              type: "number",
              placeholder: _ctx.$t('withdraw.brazilIdPlaceholder')
            }, {
              "right-icon": _withCtx(() => [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("withdraw.brazilId")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      (_unref(withdrawStore).selectedChannel.channelType == '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_van_field, {
              modelValue: bank.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((bank).value = $event)),
              disabled: _ctx.dataSetTwo?.isDisabled && _unref(withdrawStore).withdrawInfo.bank != null && _unref(withdrawStore).withdrawInfo.bank != '',
              type: "text",
              placeholder: _ctx.$t('withdraw.bankPlaceholder')
            }, {
              "left-icon": _withCtx(() => [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("withdraw.bankName")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "placeholder"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})